import { ReactNode } from "react";

type DialogHeadingProps = {
  children: ReactNode;
};

export const DialogHeading = ({ children }: DialogHeadingProps) => {
  return <h2 className="modal__section-title">{children}</h2>;
};
